(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('printDialogue', {
        templateUrl: 'views/components/views/printDialogue/printDialogue.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: [
            '$stateParams',
            'stateService',
            'utilityService',
            'modalService',
            'printDialogueService',
            'printService',
            'ieScreenBlockService',
            'dbReportService',
            'p2ReportDefService',
            'pdfService',
            'translateService',
            'rememberService',
            function ($stateParams, stateService, utilityService, modalService, printDialogueService, printService, ieScreenBlockService, dbReportService, p2ReportDefService, pdfService, translateService, rememberService) {
                // #region VARIABLES & DEFINITIONS

                const vm = this;
                let webPageName = $stateParams.webpage_name;
                let argType = $stateParams.argtype;
                let argValue = $stateParams.argvalue;
                let p2ReportDefKeyno = $stateParams.p2_reportdef_keyno;

                var reportDefinitions = {};

                var translations = {
                    printdialogue_confirm_title: '',
                    printdialogue_confirm_message: '',
                    printdialogue_confirm_ok_label: '',
                    printdialogue_confirm_cancel_label: '',
                };

                vm.model = {
                    argType: $stateParams.argtype,
                    argValue: $stateParams.argvalue,
                    reportKeyno: 0,
                    dbReport: {},
                    currentReport: {},
                    selectListPrinters: [],
                    //isLandscape: '0'
                };

                // #endregion VARIABLES & DEFINITIONS

                // #region LOAD PROCEDURE FUNCTION CALLS

                async function load() {
                    console.log('load');

                    ieScreenBlockService.start();

                    console.log('01');

                    printDialogueService.load(p2ReportDefKeyno).then(function (data) {
                        console.log('data');
                        console.dir(data);

                        angular.copy(data.dbReport, vm.model.dbReport);

                        angular.copy(data.report, vm.model.currentReport);

                        console.log('02');

                        angular.copy(data.printers, vm.model.selectListPrinters);

                        console.log('03');

                        vm.model.reportKeyno = data.reportKeyno;

                        console.log('04');

                        //vm.model.isLandscape = data.isLandscape;
                        ieScreenBlockService.stop();

                        console.log('05');
                    });
                }

                async function loadReportDefinitions() {
                    reportDefinitions = (await p2ReportDefService.getEdit({ p2_reportdef_keyno: p2ReportDefKeyno }))[0];
                }

                // #endregion LOAD PROCEDURE FUNCTION CALLS

                // #region PRINT BUTTON FUNCTION

                vm.print = async function () {
                    if (angular.isUndefined(vm.model.currentReport.default_printer_keyno) || vm.model.currentReport.default_printer_keyno === null || vm.model.currentReport.default_printer_keyno === '0') {
                        modalService.confirm({
                            type: 'danger',
                            title: translations.printdialogue_confirm_title,
                            message: translations.printdialogue_confirm_message,
                            okLabel: translations.printdialogue_confirm_ok_label,
                            cancelLabel: translations.printdialogue_confirm_cancel_label,
                        });
                    } else {
                        var parms = {
                            reportKeyno: vm.model.currentReport.report_keyno,
                            printerKeyno: vm.model.currentReport.default_printer_keyno,
                            copies: vm.model.currentReport.default_count,
                            parameters: {},
                        };

                        parms.parameters[vm.model.argType] = vm.model.argValue;

                        ieScreenBlockService.start();

                        if (vm.model.dbReport.report_type_keyno == 2) {
                            parms.reportKeyno = vm.model.currentReport.report_keyno;
                            const result = await pdfService.printPDF(parms);
                            if (result.errorcode != 0) {
                                modalService.confirm({
                                    type: 'danger',
                                    title: result.errormessage,
                                    message: result.errormessage,
                                    okLabel: translations.printdialogue_confirm_ok_label,
                                    cancelLabel: translations.printdialogue_confirm_cancel_label,
                                });
                            }
                        } else {
                            // 20250424 EO/PAH - For telerik we need to use the keyno in the Print Server database
                            // parms.reportKeyno = vm.model.currentReport.report_keyno;
                            parms.reportKeyno = vm.model.dbReport.printserver_keyno;

                            parms.printerProperties = {
                                isLandscape: reportDefinitions.isLandscape,
                                pageAutoSize: true,
                                copies: vm.model.currentReport.default_count,
                            };

                            // BJS 20200221
                            if (reportDefinitions.paper_size_id === 'custom') {
                                parms.printerProperties.pageAutoSize = false;
                                parms.printerProperties.scale = 'none';
                                parms.printerProperties.paperSize = {
                                    width: reportDefinitions.width,
                                    height: reportDefinitions.height,
                                };
                            }
                            await printService.print(parms);
                        }
                        ieScreenBlockService.stop();
                    }
                };

                // #endregion PRINT BUTTON FUNCTION

                // #region MULTI DIRECTION BUTTON FUNCTIONS

                vm.goToFunc = async function (state, e) {
                    function go(parms) {
                        if (e?.ctrlKey) {
                            stateService.newTab(state, parms);
                        } else {
                            stateService.go(state, parms);
                        }
                    }

                    switch (state) {
                        case 'printpreview':
                            go({
                                report_keyno: p2ReportDefKeyno, // BJS 20241017 - MÅ sende reportdef_keyno her, IKKE htmlreport_keyno
                                printer_keyno: vm.model.currentReport.default_printer_keyno,
                                webpage: webPageName,
                                argtype: argType,
                                argvalue: argValue,
                            });
                            break;
                        case 'emailcreate':
                            await rememberService.remember('goto.emailcreate.selectedreport', p2ReportDefKeyno);

                            go({
                                webpage: webPageName,
                                argtype: argType,
                                argvalue: argValue,
                            });
                            break;
                        default:
                            break;
                    }
                };

                // #endregion MULTI DIRECTION BUTTON FUNCTIONS

                // #region TRANSLATION FUNCTION

                translateService.translateBatch(translations).then(function (data) {
                    angular.forEach(translations, function (_, key) {
                        if (angular.isDefined(data[key])) {
                            translations[key] = data[key];
                        }
                    });
                });

                // #endregion TRANSLATION FUNCTION

                // #region FIELD CHANGE MULTI FUNCTIONS

                vm.onChanged = function (value, id) {
                    switch (id) {
                        case 'default_printer_keyno':
                            if (utilityService.validateWatchValue(value, vm.model.currentReport.default_printer_keyno) !== true) return;

                            vm.model.currentReport.default_printer_keyno = value;

                            if (utilityService.validateParmsValue(vm.model.currentReport.default_printer_keyno, true) !== true) return;

                            dbReportService.setUserReportPrinter(vm.model.reportKeyno, vm.model.currentReport.default_printer_keyno);
                            break;
                        default:
                            utilityService.setValueToVariable(value);
                            break;
                    }
                };

                // #endregion FIELD CHANGE MULTI FUNCTIONS

                // #region ON INIT FUNCTION

                vm.$onInit = function () {
                    load();
                    loadReportDefinitions();
                };

                // #endregion ON INIT FUNCTION
            },
        ],
    });
})();
